import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
} from '@mui/material';
import {
  Add as AddIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import { CtaButton } from '../../../../../types';
import { CtaButtonCard } from './CtaButtonCard';

interface CtaButtonListProps {
  ctaButtons: CtaButton[];
  onEdit: (ctaButton: CtaButton) => void;
  onDelete: (id: string) => void;
  onAdd: () => void;
}

// IDから作成日時を取得（cta-1234567890 形式）。取得できない場合は0
const getCreatedTime = (id: string): number => {
  const num = id.replace(/^cta-/, '');
  const n = parseInt(num, 10);
  return Number.isNaN(n) ? 0 : n;
};

// 新しい順でソート
const sortByNewestFirst = (buttons: CtaButton[]): CtaButton[] =>
  [...buttons].sort((a, b) => getCreatedTime(b.id) - getCreatedTime(a.id));

export const CtaButtonList: React.FC<CtaButtonListProps> = ({
  ctaButtons,
  onEdit,
  onDelete,
  onAdd
}) => {
  const sortedButtons = React.useMemo(() => sortByNewestFirst(ctaButtons), [ctaButtons]);

  return (
    <Box sx={{ p: 3, height: '100%', overflow: 'auto' }}>
      {/* ヘッダー */}
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, fontSize: '20px' }}>
        CTAボタン管理
      </Typography>

      {/* ボタン一覧 */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, 320px)',
          gap: 2,
        }}
      >
        {/* 空のスロット（常に左上に表示） */}
        <Card
          sx={{
            border: '2px dashed #D0D0D0',
            borderWidth: '2px',
            borderStyle: 'dashed',
            borderColor: '#D0D0D0',
            borderRadius: '12px',
            backgroundColor: '#F0F0F0',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '320px',
            height: '360px',
            boxShadow: 'none',
            outline: 'none',
            transition: 'background-color 0.2s',
            order: -1,
            '&:hover': {
              backgroundColor: '#E0E0E0',
            }
          }}
          onClick={onAdd}
        >
          <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 2 }}>
            <AddIcon sx={{ fontSize: '2.5rem', color: '#999999' }} />
          </CardContent>
        </Card>
        
        {/* 登録済みのCTAボタン（新しい順で表示） */}
        {sortedButtons.map((ctaButton) => (
          <CtaButtonCard
            key={ctaButton.id}
            ctaButton={ctaButton}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </Box>
    </Box>
  );
};

